import values from 'lodash/values';

import createSort from '../../../shared/table/create-sort.js';

const defaultInitialState = {
	columns: {
		affiliate: {
			index: 'affiliate',
			title: 'Email',
			direction: 'desc'
		},
		accepted_crm_conversions: {
			index: 'accepted_crm_conversions',
			title: 'Accepted',
			direction: 'desc',
			className: 'modify--right-position'
		},
		redeem_percent: {
			index: 'redeem_percent',
			title: 'Redeemed',
			direction: 'desc',
			className: 'modify--left-position'
		},
		average_redeem_percent: {
			title: 'Average redeem',
			className: 'modify--right-position'
		},
		redeem_deviation: {
			title: 'Deviation',
			className: 'modify--right-position'
		}
	},
	sortByColumn: {
		index: 'affiliate',
		title: 'Email',
		direction: 'desc'
	}
};

const createTable = ({
	namespace,
	stateNodeName
}) => {
	const sort = createSort(namespace, stateNodeName, {
		type: 'local',
		resolverSortFn: sortedColumn => row => {
			const value = row[sortedColumn.index];
			switch (sortedColumn.index) {
				case 'redeem_percent':
					return parseFloat(value);
				default:
					return value;
			}
		}
	});

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = Object.assign({}, sort.actions);

	// reducers
	const reducers = Object.assign({}, sort.reducers);

	// selectors
	const selectors = {
		getTable: state => {
			const { table, data } = state[namespace];
			const rows = data ? sort.order(data, table.sortByColumn) : [];

			return {
				headers: values(table.columns),
				rows,
				sortedColumn: table.sortByColumn,
				rowsNumber: table.rowsNumber,
				totalRows: rows.length
			};
		}
	};

	return {
		initialState,
		selectors,
		actions,
		reducers
	};
};

export default createTable;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates-redeem/components/table/index.js